/**
 * We want to avoid string collisions *and* maintain simple names that don't become redundant in
 * context of their parents / import paths: e.g., `SuperAdminTypes.FILTERS` instead of redundant
 * `SuperAdminTypes.SUPER_ADMIN_FILTERS`. So, the underlying type strings include an `SA_` prefix,
 * while the public variable names do not.
 */

export const SELECTOR_ACTION_TYPES = {
  SELECT_TOOL: 'SA_SELECT_TOOL',
  CLEAR_TOOL_SELECTION: 'SA_CLEAR_TOOL_SELECTION',
};

// Values correspond to button text
export const TOOL_BUTTON_NAMES = {
  INSTITUTION_LICENSE: 'Institution License',
  INDIVIDUAL_LICENSE: 'Individual License',
  TASKS: 'Tasks',
  REPORTS: 'Reports',
  HELP: 'Help',
  USERS: 'Users',
  PRODUCT_VERSION: 'Product Version',
};

export const FILTER_ACTION_TYPES = {
  TOGGLE_FILTER: 'SA_TOGGLE_FILTER',
  CLEAR_FILTERS: 'SA_CLEAR_FILTERS',
};

export const TABLE_ACTION_TYPES = {
  SELECT_LICENSE_ROW: 'SA_SELECT_LICENSE_ROW',
  DESELECT_LICENSE_ROW: 'SA_DESELECT_LICENSE_ROW',
  SELECT_USER_ROW: 'SA_SELECT_USER_ROW',
  DESELECT_USER_ROW: 'SA_DESELECT_USER_ROW',
  SELECT_SUFFIX_ROW: 'SA_SELECT_SUFFIX_ROW',
  DESELECT_SUFFIX_ROW: 'SA_DESELECT_SUFFIX_ROW',
  SELECT_MULTIPLE_SUFFIX_ROW: 'SA_SELECT_MULTIPLE_SUFFIX_ROW',
  DESELECT_MULTIPLE_SUFFIX_ROW: 'SA_DESELECT_MULTIPLE_SUFFIX_ROW',
  SELECT_LICENSE_DETAILS: 'SA_SELECT_LICENSE_DETAILS',
  DESELECT_ALL_USER_ROWS: 'SA_DESELECT_ALL_USER_ROWS',
  SET_COSTCENTER_INVITES: 'SA_SET_COSTCENTER_INVITES',
  SET_COSTCENTER_DETAILS: 'SA_SET_COSTCENTER_DETAILS',
  SET_ALL_COST_CENTER_INVITES: 'SA_SET_ALL_COST_CENTER_INVITES',
  SET_COST_CENTER_INVITES_FETCH_ERROR: 'SA_SET_COST_CENTER_INVITES_FETCH_ERROR',
  SET_COST_CENTER_INVITES_CACHE: 'SA_SET_COST_CENTER_INVITES_CACHE',
  SET_COST_CENTER_INVITES_CACHE_FETCH_ERROR: 'SA_SET_COST_CENTER_INVITES_CACHE_FETCH_ERROR',
};

export const SORT_ACTION_TYPES = {
  SORT: 'SA_SORT',
  SORT_SUFFIX: 'SA_SORT_SUFFIX',
};

// Values correspond to modals in SuperAdmin
export const MODAL_TYPES = {
  CREATE_NEW_LICENSE: 'SA_CREATE_NEW_LICENSE',
  MANAGE_LICENSE: 'SA_MANAGE_LICENSE',
  LICENSE_DETAILS: 'SA_LICENSE_DETAILS',
};

// ID of "select all" checkbox
export const MASTER_CHECKBOX_ID = 'master';

export const FETCH_ACTION_TYPES = {
  FETCH_SUCCESS: 'SA_FETCH_SUCCESS',
  FETCH_ERROR: 'SA_FETCH_ERROR',
  FETCH_SEARCH_USERS: 'SA_FETCH_SEARCH_USERS',
};

export const LICENSE_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
} as const;

export type LicenseStatus = (typeof LICENSE_STATUS)[keyof typeof LICENSE_STATUS];
